// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "history" + "-legacy." + "10239e49" + ".js";
};